import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
@Component({
  selector: 'sia-email-button',
  templateUrl: './sia-email-button.component.html',
  styleUrls: ['./sia-email-button.component.scss'],
  standalone: true,
  imports: [MatIconButton, MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaEmailButtonComponent {
  readonly email = input<string>('');

  openUserEmail() {
    const email = this.email();

    if (email) {
      document.location.href = 'mailto:' + email;
    }
  }
}
